import React from 'react';
import PropTypes from 'prop-types';
import TextFormatter from 'utils/TextFormatter';
import MenuItem from 'material-ui/MenuItem';

const PhoneLink = (props) => {

    const {label, accountCustomerInfo, phoneKey} = props;

    if (!accountCustomerInfo || !accountCustomerInfo.get(phoneKey)) {
        return null;
    }

    const phoneNumber = accountCustomerInfo.get(phoneKey);

    const cleanPhoneNumber = TextFormatter.cleanPhoneNumber(phoneNumber);

    if (!cleanPhoneNumber) {
        return (<MenuItem
            style={{
            width: '275px'
        }}
            secondaryText="N/A"
            primaryText={label}/>);
    }

    const onTouchTap = (e) => {
        e.preventDefault();
        window.open('tel:' + cleanPhoneNumber, '_parent');

    };

    return (<MenuItem
        style={{
        width: '275px'        
    }}
        className="phone-hyperlinked"
        onTouchTap={onTouchTap}
        value={cleanPhoneNumber}
        secondaryText={TextFormatter.formatPhoneNumber(phoneNumber)}
        primaryText={label}/>);

};

PhoneLink.propTypes = {
    label: PropTypes.string,
    accountCustomerInfo: PropTypes.object,
    phoneKey: PropTypes.string
};

export default PhoneLink;



// WEBPACK FOOTER //
// ./src/components/work-order/PhoneLink.js